import { journey_driverService } from '../_services';

const state = { onRequest: false, journey_driver: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        journey_driverService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  journey_driver: state => {
    return state.journey_driver
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.journey_driver = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.journey_driver = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.journey_driver = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const journey_drivers = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
